export default __webpack_public_path__ + "pdf/oferta.4523e6a0.pdf";